import React, { useEffect, useMemo, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import useChatStore from '../../store/useChatStore';
import showToast from '../../utility/showToast';

const maskMobile = (value) => {
  if (!value) return 'Mobile not verified';
  const digits = value.toString();
  if (digits.length <= 4) return digits;
  return digits.replace(/.(?=.{4})/g, '•');
};

const DashboardProfileMenu = ({ onResumeLatest, onSupport, onViewProfile, onLogout }) => {
  const customer = useChatStore((state) => state.customer);
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  const name = customer?.name || customer?.customerName || 'GrowBizh Customer';
  const mobile = customer?.mobile || customer?.mobileNumber || '';
  const maskedMobile = useMemo(() => maskMobile(mobile), [mobile]);
  const avatarSrc = customer?.avatarUrl || '/images/profile-icon.png';

  useEffect(() => {
    const handler = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const triggerAction = (callback, fallbackMessage) => {
    if (typeof callback === 'function') {
      callback();
    } else if (fallbackMessage) {
      showToast(fallbackMessage, 'info');
    }
    setOpen(false);
  };

  return (
    <div className="dashboard-profile-menu" ref={dropdownRef}>
      <button
        type="button"
        className="header-profile-pill"
        onClick={() => setOpen((prev) => !prev)}
        aria-label={`Profile menu for ${name} (${maskedMobile})`}
      >
        <div className="header-profile-avatar">
          <img src={avatarSrc} alt={name} />
        </div>
      </button>
      {open && (
        <div className="dashboard-profile-dropdown">
          <button type="button" onClick={() => triggerAction(onLogout)}>
            <img src="/images/logout-icon.png" alt="" />
            Logout
          </button>
        </div>
      )}
    </div>
  );
};

DashboardProfileMenu.propTypes = {
  onResumeLatest: PropTypes.func,
  onSupport: PropTypes.func,
  onViewProfile: PropTypes.func,
  onLogout: PropTypes.func,
};

DashboardProfileMenu.defaultProps = {
  onResumeLatest: null,
  onSupport: null,
  onViewProfile: null,
  onLogout: null,
};

export default DashboardProfileMenu;

